import axios from 'axios';
import { setIdToken } from '@/features/redux/slices/authSlice';
import { store, logout } from '@/features/redux/store';
import { createUri, Api } from './utils';

export enum UserUrls {
    SignIn = '/signIn',
    RefreshToken = '/refreshToken',
    AdminUsers = '/admin/users',
    ResetPass = '/requestPassReset',
    ConfirmPass = '/confirmPassReset',
    Users = '/users',
}

const AUTH_URL = createUri(Api.Auth, '/auth/V1');

export const authApi = axios.create({
    baseURL: AUTH_URL,
});

export const signIn = (email: string, password: string) => {
    return authApi.post(UserUrls.SignIn, {
        email,
        password,
    });
};

export const refreshToken = async (token: string) => {
    try {
        const resp = await authApi.post(UserUrls.RefreshToken, {
            token,
        });

        const { IdToken } = resp.data.AuthenticationResult;

        store.dispatch(setIdToken(IdToken));
    } catch (e) {
        logout();
    }
};
